import { CustomButton } from "@/components/ui/Buttons";
import { Dispatch, SetStateAction, useState } from "react";
import InfoIcon from "@/assets/icons/InfoCircle.svg";
import BenchmarkEditIcon from "@/assets/icons/BenchmarkEditIcon.svg";
import VideoPlayerV3 from "@/components/ui/VideoPlayerV3";
import Mp4AdvancedPlayer from "@/components/ui/Mp4AdvancedPlayer";

const benchmarks = [
  {
    title: "Clear voice",
    description: "no clipping/noise; music (if used) stays under dialogue",
  },
  {
    title: "Tight pacing",
    description: "trim dead air & mistakes; clean jump cuts OK",
  },
  {
    title: "Light polish",
    description: "basic color/exposure balance; stable framing ",
  },
  {
    title: "Simple text and Cation",
    description: "1–3 on-screen callouts or captions (no heavy graphics)",
  },
  {
    title: "Brand fit",
    description: " use provided logo/colors if shared; no watermarks",
  },
  {
    title: "Music",
    description: "basic UGC standards. Non-copyright music",
  },
];

const benchMarkData = [
  {
    video_url:
      "https://assets.passionbits.io/uploads/videos/1767853293928_28ad20ee138aa8_Testimonial_LDS.mp4",
    thumbnail:
      "https://assets.passionbits.io/uploads/video-thumbnails/1767853331297_5e2d31967be57.webp",
    hash: "UKI5lL009G.9t:8^xu%hXn%LR5V[ROt8j[og",
  },

  {
    video_url:
      "https://assets.passionbits.io/uploads/videos/1767853518110_e89234add52f5_Day_1.mp4",
    thumbnail:
      "https://assets.passionbits.io/uploads/video-thumbnails/1767853749659_439f0f5dfa378.webp",
    hash: "UtO{Kq${?Z-;.AWBtRx]%zbHR+kCRRWEaLVt",
  },
];
const Benchmark = ({
  setShowBenchMark,
}: {
  setShowBenchMark: Dispatch<SetStateAction<boolean>>;
}) => {
  const [playingUrl, setPlayingVideoUrl] = useState("");

  const handlePlayVideo = (url: string) => {
    if (playingUrl === url) {
      setPlayingVideoUrl("");
    } else {
      setPlayingVideoUrl(url);
    }
  };
  return (
    <div>
      <div className="flex items-center gap-x-3 mb-[27px]">
        <BenchmarkEditIcon />
        <h4 className="text-base font-semibold leading-5 tracking-normal">
          Editing Benchmark — Basic UGC
        </h4>
      </div>
      <ul className="space-y-5 list-disc ps-6">
        {benchmarks.map((item) => (
          <li id={item.title}>
            <span className="text-[#222222] font-semibold text-sm leading-5 tracking-normal">
              {item.title}:
            </span>{" "}
            <span className="text-[#475467] text-sm font-medium italic leading-normal">
              {item.description}
            </span>
          </li>
        ))}
      </ul>
      <div className="mt-6">
        <p className="text-[#475467] text-xs leading-5 mb-2">
          See 30-sec examples{" "}
        </p>
        <div className="flex gap-6">
          {benchMarkData.map((item, i) => (
            <div className="bg-[#F4F4F4] overflow-hidden size-[173px] rounded-lg">
              <Mp4AdvancedPlayer
                key={i}
                playing={playingUrl === item.video_url}
                onPlay={() => handlePlayVideo(item.video_url)}
                src={item.video_url as string}
                blurhash={item.hash}
                thumbnailUrl={item.thumbnail}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="bg-[#FFF3EA] p-2 rounded-lg mt-6 flex items-center gap-x-2">
        <div>
          <InfoIcon />
        </div>
        <p className="text-[#475467] text-xs leading-[18px] tracking-normal">
          <span className="font-medium">Fails if:</span> raw dump/no editing,
          muffled or distorted audio, shaky/unreadable shots, wrong
          aspect/length, off-brand fonts, or typo-ridden text.
        </p>
      </div>
      <CustomButton
        onClick={() => setShowBenchMark(false)}
        variant="outline"
        color="#344054"
        fontWeight="600"
        fontSize="16px"
        padding="10px"
        border="0px"
        className="mt-6 w-full btn-shadow"
      >
        Got it
      </CustomButton>
    </div>
  );
};

export default Benchmark;
